import { render, staticRenderFns } from "./LearnRankList.vue?vue&type=template&id=cb81dbfa&scoped=true&"
import script from "./LearnRankList.vue?vue&type=script&lang=js&"
export * from "./LearnRankList.vue?vue&type=script&lang=js&"
import style0 from "./LearnRankList.vue?vue&type=style&index=0&id=cb81dbfa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb81dbfa",
  null
  
)

export default component.exports